import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { BehaviorSubject, Subject } from 'rxjs';
import { EventType, getEmptyEventType } from 'src/app/interfaces/event-type';
import { EmailListService } from 'src/app/services/emaillist.service';
import { EventtypeService } from 'src/app/services/eventtype.service';
import { LocationService } from 'src/app/services/location.service';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  // company: any;
  // mailing_lists: any;
  // eventtypes: any;
  // companyid: any;
  // event: any;
  selectSetting: number = 0;
  slides: any;
  behavior = new BehaviorSubject(5)


  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  config: SwiperOptions = {
    spaceBetween: 10,
    // preventInteractionOnTransition: true,

    //rene ////////////////////////////////////////////////7
    // rene zum aus und einschalten vom Swiper links rechtsionic serve
    //rene ////////////////////////////////////////////////7
    allowSlideNext: true,
    allowSlidePrev: true,
    pagination: { clickable: true }, //Punkte unten
  };

  constructor(
    private storage: Storage,
    private locationService: LocationService,
    private menu: MenuController

  ) {
    this.behavior.subscribe(x => {
      this.slides = x
    })
  }

  async ngOnInit() {
  }

  async openCompany() {
    this.selectSetting = 0;
  }

  async openLocation() {
    this.selectSetting = 1;
  }

  async openEvent() {
    this.selectSetting = 2;
  }

  async openQuestionList() {
    this.selectSetting = 3;
  }

  async openUsers() {
    this.selectSetting = 4;
  }

  async openHolydays() {
    this.selectSetting = 5;
  }

  menuOpen() {
    this.menu.open();
  }

  // TODO: SLIDE PLUS MINUS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  slidePlus() {
    if (this.slides < 6) {
      this.slides++;
      this.behavior.next(this.slides)
    }
    console.log(this.slides)
  }

  slideMinus() {
    if (this.slides > 1)
      this.slides--;

    this.behavior.next(this.slides)
    console.log(this.slides)
  }
}